"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOrderPreviewItemHash = calculateOrderPreviewItemHash;
exports.prepareOrderItemsBody = prepareOrderItemsBody;
var _lodash = require("lodash");
var _md = _interopRequireDefault(require("md5"));
var _orderItemStatusEnum = _interopRequireDefault(require("../enums/orderItemStatusEnum"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function mergeOrderItemsForPreview(_ref) {
  let {
    order,
    currentOrderItem
  } = _ref;
  let orderItemsIds = [...order.orderItemsIds];
  const orderItems = {
    ...order.orderItems
  };
  if (currentOrderItem && currentOrderItem.orderItemStatus > _orderItemStatusEnum.default.INITIAL) {
    orderItems[currentOrderItem.apiId] = currentOrderItem;
    orderItemsIds.push(currentOrderItem.apiId);
  }
  orderItemsIds = (0, _lodash.uniq)(orderItemsIds);
  return {
    orderItemsIds,
    orderItems
  };
}
function prepareOrderItemBody(_ref2) {
  let {
    orderItem,
    preview
  } = _ref2;
  const ingredientsServingsStoreKey = preview ? "highlightedIngredientServings" : "selectedIngredientServings";
  return orderItem.personalSettings.map(personalSetting => ({
    menu_item: orderItem.apiId,
    personal_settings: personalSetting,
    landing_page_slug: orderItem.landingPageSlug,
    ingredient_servings: (0, _lodash.mapValues)(orderItem[ingredientsServingsStoreKey], servings => servings.toString()),
    is_upsold: orderItem.isUpsold || false
  }));
}

/* Serializes order items data for submission to the order api */
function prepareOrderItemsBody(_ref3) {
  let {
    order,
    currentOrderItem,
    preview
  } = _ref3;
  const {
    orderItemsIds,
    orderItems
  } = mergeOrderItemsForPreview({
    order,
    currentOrderItem
  });
  return orderItemsIds.map(orderItemId => orderItems[orderItemId]).map(orderItem => prepareOrderItemBody({
    orderItem,
    preview
  })).reduce((a, b) => [...a, ...b], []);
}
function menuItemIngredientServingsHash(_ref4) {
  let {
    menuItemId,
    ingredientServingsPairs
  } = _ref4;
  const stringifiedIngredientServings = (0, _lodash.flatten)((0, _lodash.sortBy)(ingredientServingsPairs, pair => parseFloat(pair[0])));
  return (0, _md.default)("".concat(menuItemId).concat(stringifiedIngredientServings));
}
function calculateOrderPreviewItemHash(orderPreviewItem) {
  const ingredientServingsPairs = orderPreviewItem.menu.ingredients.map(ingredient => [ingredient.ingredient, parseFloat(ingredient.serving)]);
  return menuItemIngredientServingsHash({
    menuItemId: orderPreviewItem.menu.id,
    ingredientServingsPairs
  });
}